import React from 'react';
import axios from 'axios';
import { DropdownItem } from 'reactstrap';
import Cookies from '../../../../util/cookies';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const dropdownStyle = {
	textAlign: 'left',
	cursor: 'pointer'
};

export default class SignoutButton extends React.Component {
	handleSignoutSubmit = event => {
		event.preventDefault();
		Cookies.delete(config.giveCookie);

		axios({
			method: 'post',
			url: `/auth/signout`,
			data: {
				_csrf: this.props._csrf
			}
		}).then(response => {
			window.location.href = window.location.href;
			Cookies.delete('GI_TOKEN');
			localStorage.removeItem("CF_BEARER_TOKEN");
		});

		if (window.eventDispatcher) {
			window.eventDispatcher.dispatchEventSync(
				'logout',
				{},
				{ amplitude: true }
			);
		}
		return false;
	};

	render() {
		return (
			<DropdownItem href="#" onClick={this.handleSignoutSubmit}>
				Sign Out
			</DropdownItem>
		);
	}
}
